import { useEffect, useState } from 'react'
import { I18nProvider } from '@lingui/react'
import { i18n } from '@lingui/core'
import App from './App.tsx'
import { BossMantineProvider } from '@m3-tech/boss-ui'
import { detectLocale, loadCatalog } from './i18n'

export function I18nApp() {
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        const locale = detectLocale()
        loadCatalog(locale)
            .then(() => setIsLoaded(true))
            .catch(console.error)
    }, [])

    if (!isLoaded) {
        return null // Or a loading spinner
    }

    return (
        <I18nProvider i18n={i18n}>
            <BossMantineProvider>
                <App />
            </BossMantineProvider>
        </I18nProvider>
    )
}
